import type { CharacterEncounter } from '../types/character.types';
import { characterLabel, type CharacterLanguage } from './character-labels';
import { journalAction } from './character-journal-copy';
function record(value: unknown): value is Record<string, unknown> {
  return !!value && typeof value === 'object' && !Array.isArray(value);
}
function text(value: unknown, max: number): value is string {
  return (
    typeof value === 'string' && value.trim().length > 0 && value.length <= max
  );
}
export function encounterActionLabel(
  encounter: CharacterEncounter,
  language: CharacterLanguage,
  id: string,
): string {
  const metadata = encounter.knownContext?.optionMetadata;
  if (record(metadata) && record(metadata[id])) {
    const value = metadata[id][language === 'ru' ? 'labelRu' : 'labelEn'];
    if (text(value, 160)) return value;
  }
  return journalAction(language, id);
}
export function encounterDescription(
  encounter: CharacterEncounter,
  language: CharacterLanguage,
): string {
  const value =
    encounter.knownContext?.[
      language === 'ru' ? 'descriptionRu' : 'descriptionEn'
    ];
  if (text(value, 1000)) return value;
  if (encounter.templateId === 'wounded_civilian')
    return language === 'ru'
      ? 'На дороге раненый путник.'
      : 'A wounded traveler lies by the road.';
  return language === 'ru'
    ? 'Герой встретил событие на пути.'
    : 'The hero encountered an event.';
}
export function encounterTravelSeconds(
  encounter: CharacterEncounter,
  id: string,
): number | null {
  const metadata = encounter.knownContext?.optionMetadata;
  if (!record(metadata) || !record(metadata[id])) return null;
  const value = metadata[id].durationSeconds;
  return typeof value === 'number' && Number.isFinite(value) && value > 0
    ? value
    : null;
}

export function encounterRiskLabel(language: CharacterLanguage, risk: string): string {
  return ['healing_may_fail', 'possible_resistance', 'travel_danger'].includes(risk)
    ? characterLabel(language, risk) : risk;
}
